export const availableFeatures: string[] = [
    // Architecture Types
    "architectureType: 1.5 Story",
    "architectureType: 2+ Story",
    "architectureType: A-Frame",
    "architectureType: Apartment",
    "architectureType: Bi-Level",
    "architectureType: Bungalow",
    "architectureType: Cabin",
    "architectureType: Cape Cod",
    "architectureType: Chalet",
    "architectureType: Colonial",
    "architectureType: Colonial Revival",
    "architectureType: Condo",
    "architectureType: Condominium",
    "architectureType: Contemporary",
    "architectureType: Conventional",
    "architectureType: Cottage",
    "architectureType: Custom",
    "architectureType: Dome",
    "architectureType: Duplex",
    "architectureType: English",
    "architectureType: European",
    "architectureType: Farm House",
    "architectureType: French Provincial",
    "architectureType: Gambrel",
    "architectureType: Georgian",
    "architectureType: High Rise",
    "architectureType: Historical",
    "architectureType: Log Cabin",
    "architectureType: Low Rise",
    "architectureType: Mansion",
    "architectureType: Manufactured",
    "architectureType: Mediterranean",
    "architectureType: Mid Rise",
    "architectureType: Mobile Home",
    "architectureType: Modern",
    "architectureType: Modular",
    "architectureType: Multi-family",
    "architectureType: Multi-Unit Building",
    "architectureType: Other",
    "architectureType: Old Style",
    "architectureType: Prefab",
    "architectureType: Quadruplex",
    "architectureType: Raised Ranch",
    "architectureType: Rambler",
    "architectureType: Ranch",
    "architectureType: Ranch House",
    "architectureType: Row End or Row Middle",
    "architectureType: Rustic",
    "architectureType: Single Story",
    "architectureType: Southwestern",
    "architectureType: Spanish",
    "architectureType: Split Entry",
    "architectureType: Split Foyer",
    "architectureType: Split Level",
    "architectureType: Townhouse",
    "architectureType: Traditional",
    "architectureType: Triplex",
    "architectureType: Tudor",
    "architectureType: Two Family",
    "architectureType: Under Construction",
    "architectureType: Victorian",

    // Cooling Types
    "coolingType: Central",
    "coolingType: Chilled Water",
    "coolingType: Commercial",
    "coolingType: Evaporative",
    "coolingType: Fan Cooling",
    "coolingType: Geo-Thermal",
    "coolingType: Other",
    "coolingType: Package",
    "coolingType: Partial",
    "coolingType: Refrigeration",
    "coolingType: Solar",
    "coolingType: Split System",
    "coolingType: Ventilation",
    "coolingType: Wall",
    "coolingType: Window",

    // Exterior Types
    "exteriorType: Adobe",
    "exteriorType: Aluminum",
    "exteriorType: Aluminum Lap",
    "exteriorType: Aluminum Siding",
    "exteriorType: Asbestos Shingle",
    "exteriorType: Asphalt Shingle",
    "exteriorType: Baked Enamel",
    "exteriorType: Block",
    "exteriorType: Board & Batten",
    "exteriorType: Brick",
    "exteriorType: Brick Veneer",
    "exteriorType: Cinder Block",
    "exteriorType: Combination",
    "exteriorType: Composition",
    "exteriorType: Concrete",
    "exteriorType: Concrete Block",
    "exteriorType: Frame",
    "exteriorType: Frame Brick",
    "exteriorType: Frame Siding",
    "exteriorType: Glass",
    "exteriorType: Log",
    "exteriorType: Marble",
    "exteriorType: Marblecrete",
    "exteriorType: Masonite",
    "exteriorType: Masonry",
    "exteriorType: Metal",
    "exteriorType: Metal Siding",
    "exteriorType: Other",
    "exteriorType: Plywood",
    "exteriorType: Precast Concrete Panel",
    "exteriorType: Protective",
    "exteriorType: Ribbed",
    "exteriorType: Ribbed Aluminum",
    "exteriorType: Rock",
    "exteriorType: Shake",
    "exteriorType: Shingle",
    "exteriorType: Shingle Siding",
    "exteriorType: Siding",
    "exteriorType: Single Wall",
    "exteriorType: Steel Panel",
    "exteriorType: Stone",
    "exteriorType: Stone Veneer",
    "exteriorType: Stucco",
    "exteriorType: Tile",
    "exteriorType: Veneer",
    "exteriorType: Vinyl",
    "exteriorType: Vinyl Siding",
    "exteriorType: Wood",
    "exteriorType: Wood Frame",
    "exteriorType: Wood Shingle",
    "exteriorType: Wood Siding",

    // Fireplace Types
    "fireplaceType: 1 Story",
    "fireplaceType: 1 Story Brick Chimney",
    "fireplaceType: 2 Story",
    "fireplaceType: 2 Story Brick Chimney",
    "fireplaceType: Backed",
    "fireplaceType: Flue Only",
    "fireplaceType: Gas Log",
    "fireplaceType: Masonry",
    "fireplaceType: Metal",
    "fireplaceType: Other",
    "fireplaceType: Prefab",
    "fireplaceType: Single",
    "fireplaceType: Stacked",
    "fireplaceType: Stacked Stone",
    "fireplaceType: Steel",

    // Foundation Types
    "foundationType: Block",
    "foundationType: Block with Runner",
    "foundationType: Brick",
    "foundationType: Concrete",
    "foundationType: Concrete Block",
    "foundationType: Crawl",
    "foundationType: Crossed Walls",
    "foundationType: Footing",
    "foundationType: Girder",
    "foundationType: Masonry",
    "foundationType: Mat",
    "foundationType: Mud Sill",
    "foundationType: Other",
    "foundationType: Pier",
    "foundationType: Pile",
    "foundationType: Post & Beam",
    "foundationType: Raft",
    "foundationType: Raised",
    "foundationType: Retaining Wall",
    "foundationType: Slab",
    "foundationType: Stone",
    "foundationType: Wood",

    // Garage Types
    "garageType: Attached",
    "garageType: Basement",
    "garageType: Built-in",
    "garageType: Carport",
    "garageType: Covered",
    "garageType: Detached",
    "garageType: Garage",
    "garageType: Mixed",
    "garageType: Other",
    "garageType: Offsite",
    "garageType: Open",
    "garageType: Parking Lot",
    "garageType: Parking Structure",
    "garageType: Paved",
    "garageType: Surfaced",
    "garageType: Underground",

    // Heating Types
    "heatingType: Baseboard",
    "heatingType: Central",
    "heatingType: Coal",
    "heatingType: Convection",
    "heatingType: Electric",
    "heatingType: Floor",
    "heatingType: Floor Furnace",
    "heatingType: Forced Air",
    "heatingType: Forced Air Gas",
    "heatingType: Furnace",
    "heatingType: Gas",
    "heatingType: Gravity",
    "heatingType: Heat Pump",
    "heatingType: Hot Air",
    "heatingType: Hot Water",
    "heatingType: Oil",
    "heatingType: Other",
    "heatingType: Package",
    "heatingType: Partial",
    "heatingType: Propane",
    "heatingType: Radiant",
    "heatingType: Solar",
    "heatingType: Space",
    "heatingType: Steam",
    "heatingType: Stove",
    "heatingType: Vent",
    "heatingType: Wall",
    "heatingType: Warm Air",
    "heatingType: Zone",

    // Pool Types
    "poolType: Above-Ground Pool",
    "poolType: Community Pool",
    "poolType: Commercial Pool",
    "poolType: Concrete",
    "poolType: Enclosed Pool",
    "poolType: Fiberglass",
    "poolType: Gunite",
    "poolType: Heated Pool",
    "poolType: Hot Tub",
    "poolType: In-Ground Pool",
    "poolType: In-Ground Vinyl Pool",
    "poolType: Indoor Pool",
    "poolType: Municipal",
    "poolType: Other",
    "poolType: Plastic",
    "poolType: Plastic Lined",
    "poolType: Plastic w/ Vinyl Lining",
    "poolType: Pool and Hot Tub",
    "poolType: Public",
    "poolType: Reinforced Concrete",
    "poolType: Spa",
    "poolType: Vinyl",

    // Roof Types
    "roofType: Aluminum",
    "roofType: Asbestos",
    "roofType: Asphalt",
    "roofType: Asphalt Shingle",
    "roofType: Built-up",
    "roofType: Cedar Shake",
    "roofType: Clay Tile",
    "roofType: Composition Shingle",
    "roofType: Concrete",
    "roofType: Concrete Tile",
    "roofType: Fiberglass",
    "roofType: Galvanized",
    "roofType: Gambrel",
    "roofType: Gravel",
    "roofType: Metal",
    "roofType: Other",
    "roofType: Rock",
    "roofType: Roll Composition",
    "roofType: Roll Paper",
    "roofType: Roll Tar & Gravel",
    "roofType: Shake",
    "roofType: Shingle",
    "roofType: Slate",
    "roofType: Slate Tile",
    "roofType: Steel",
    "roofType: Tar & Gravel",
    "roofType: Tile",
    "roofType: Wood",
    "roofType: Wood Shake",
    "roofType: Wood Shingle",

    // View Types
    "viewType: Airport",
    "viewType: Average",
    "viewType: Beach",
    "viewType: Canal",
    "viewType: City",
    "viewType: Corner",
    "viewType: Creek",
    "viewType: Cul-de-sac",
    "viewType: Excellent",
    "viewType: Fair",
    "viewType: Fairway",
    "viewType: Flood Plain",
    "viewType: Flood Zone",
    "viewType: Freeway",
    "viewType: Golf Course",
    "viewType: Good",
    "viewType: High Traffic Area",
    "viewType: Lake",
    "viewType: Major Street",
    "viewType: Mountain",
    "viewType: Ocean",
    "viewType: Other",
    "viewType: Park",
    "viewType: Pond",
    "viewType: River",
    "viewType: School",
    "viewType: Thoroughfare",
    "viewType: Water",
    "viewType: Waterfront",
];
